import { useMemo } from 'react';
import { exhaustiveSwitch } from './exhaustive-switch';
import {
  appGalleryBlack,
  appGallery,
  appGalleryWhite,
  appStoreBlack,
  appStore,
  appStoreWhite,
  googlePlayBlack,
  googlePlay,
  googlePlayWhite,
  ruStoreBlack,
  ruStore,
  ruStoreWhite,
} from '../assets';
import {
  APP_GALLERY_LINK,
  APP_STORE_LINK,
  GOOGLE_PLAY_LINK,
  RU_STORE_LINK,
} from '../../../links';
import { MobileStore } from '../../../types';

export const useMobileAppInfo = (store: MobileStore) => {
  return useMemo(
    () =>
      exhaustiveSwitch(store, {
        ru: () => ({
          qr: ruStore,
          link: RU_STORE_LINK,
          badge: { light: ruStoreWhite, dark: ruStoreBlack },
        }),
        apple: () => ({
          qr: appStore,
          link: APP_STORE_LINK,
          badge: { light: appStoreWhite, dark: appStoreBlack },
        }),
        huawei: () => ({
          qr: appGallery,
          link: APP_GALLERY_LINK,
          badge: { light: appGalleryWhite, dark: appGalleryBlack },
        }),

        google: () => ({
          qr: googlePlay,
          link: GOOGLE_PLAY_LINK,
          badge: { light: googlePlayWhite, dark: googlePlayBlack },
        }),
      }),
    [store]
  );
};
